/**
 *
 * @param {Route} route
 *
 * @returns {Boolean}
 */
export default function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}